<div class="quick-bet__modal-dialog">
    <div class="quick-bet__modal-dialog-header">
        <span>{{ sitecore.quickBetModalDialog.TechnicalErrorHeader }}</span>
        @if (!sitecore.quickBetModalDialog.CloseButton) {
            <div class="close-button-wrapper" (click)="close()">
                <vn-icon name="theme-ex" extraClass="ui-icon ui-icon-size-lg ui-close" />
            </div>
        }
    </div>
    <div class="quick-bet__modal-dialog-message">{{ sitecore.quickBetModalDialog.TechnicalErrorMessage }}</div>
    <div class="quick-bet__modal-dialog-button-container">
        @if (sitecore.quickBetModalDialog.CloseButton) {
            <div class="quick-bet__modal-dialog-close-button">
                <button class="technical-error-buttons w-100" ds-button kind="tertiary" size="large" variant="outline" (click)="close()">
                    {{ sitecore.quickBetModalDialog.CloseButton }}
                </button>
            </div>
        }
        <div class="quick-bet__modal-dialog-my-bets-button">
            <button class="technical-error-buttons w-100" ds-button kind="primary" size="large" (click)="goToMyBets()">
                {{ sitecore.quickBetModalDialog.GoToMyBetsButton }}
            </button>
        </div>
    </div>
</div>
